import type { SvgIconComponent } from '@mui/icons-material';
import BusinessIcon from '@mui/icons-material/BusinessOutlined';
import DashboardIcon from '@mui/icons-material/HomeOutlined';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';

export interface NavItem {
  label: string;
  to: string;
  icon: SvgIconComponent;
  end?: boolean;
}

/** The sidebar's menu, from `md` up. Settings is absent here because the
 *  sidebar carries the account block, which owns it. */
export const primaryNavigation: readonly NavItem[] = [
  { label: 'Outstanding', to: '/', icon: DashboardIcon, end: true },
  { label: 'Companies', to: '/companies', icon: BusinessIcon },
];

export const SETTINGS_PATH = '/settings';

const SETTINGS_ITEM: NavItem = { label: 'Settings', to: SETTINGS_PATH, icon: SettingsIcon };

/** The phone's tab bar. Settings is a tab here rather than a menu entry: on a
 *  phone the account menu is two taps behind an avatar in the header, which is
 *  the far corner from the thumb. Five items at most — a bottom bar with six
 *  targets is unusable with a thumb. */
export const bottomNavigation: readonly NavItem[] = [...primaryNavigation, SETTINGS_ITEM];

export const accountNavigation = {
  settings: SETTINGS_ITEM,
  logout: { label: 'Log out', icon: LogoutIcon },
} as const;
